import React, {createContext, useContext, useEffect, useState} from "react";

export const SELFIE_STATE = {
  MEDIA_INPUT: "MEDIA_INPUT",
  INSTRUCTIONS: "INSTRUCTIONS",
  PINTURA: "PINTURA",
  PREVIEW: "PREVIEW",
  THANK_YOU: "THANK_YOU",
  UPLOAD: "UPLOAD",
}

const SelfieUploadContext = createContext({})

export const SelfieUploadProvider = (
  {
    selectionMode,
    mode,
    maxVideoLengthSeconds,
    uploadFileIdentifier,
    pinturaConfig,
    thankYou,
    targetWidth,
    targetHeight,
    facingMode,
    mediaSelectButtonOrientation,
    pictureMode,
    showUploadConfirmation,
    overlayMediaFileId,
    children,
  }
) => {
  const [state, setState] = useState(SELFIE_STATE.MEDIA_INPUT)
  const recordingTime = maxVideoLengthSeconds ? Number(maxVideoLengthSeconds) : 5
  const [file, setFile] = useState(null)
  const [uploadedFile, setUploadedFile] = useState(null)

  useEffect(() => {
    if (state === SELFIE_STATE.MEDIA_INPUT && file) {
      if (mode === "video") {
        setState(SELFIE_STATE.PREVIEW)
      } else {
        setState(SELFIE_STATE.PINTURA)
      }
    }
  }, [state, setState, file]);


  return <SelfieUploadContext.Provider value={{
    selectionMode,
    mode,
    uploadFileIdentifier,
    pinturaConfig,
    thankYou,
    targetWidth,
    targetHeight,
    facingMode,
    mediaSelectButtonOrientation,
    pictureMode,
    showUploadConfirmation,
    overlayMediaFileId,

    state,
    setState,
    recordingTime,
    file,
    setFile,
    uploadedFile,
    setUploadedFile,
  }}>
    {children}
  </SelfieUploadContext.Provider>
}

export const useSelfieUploadState = () => {
  const context = useContext(SelfieUploadContext)

  if (context == null) {
    throw "useSelfieUploadState can't be used outside of a SelfieUploadProvider"
  }

  return context
}